<template>
	<popup-modal ref="popup">
		<v-card>
			<v-toolbar color="primary" dark>
				{{ title }}
				<v-spacer></v-spacer>
				<v-btn icon @click="Copy()">
					<v-icon>mdi-content-copy</v-icon>
				</v-btn>
			</v-toolbar>

			<v-card-text class="mt-4" v-html="message"></v-card-text>

			<!--                Actions-->
			<v-card-actions>
				<div class="flex-grow-1"></div>

				<v-btn @click="Positive" color="primary">{{ positive }}</v-btn>
			</v-card-actions>
		</v-card>
	</popup-modal>
</template>

<script>
import PopupModal from "@/components/PopupModal.vue"
import { mapActions } from "vuex"

export default {
	components: { PopupModal },
	data: () => ({
		title: undefined,
		message: undefined,
		positive: undefined,

		// Private variables
		resolvePromise: undefined,
		rejectPromise: undefined,
	}),

	methods: {
		...mapActions(["copyToClipBoard"]),
		show(opts = {}) {
			this.title = opts.title
			this.message = opts.message
			this.positive = opts.positive

			// Once we set our config, we tell the popup modal to open
			this.$refs.popup.open(false, false)

			// Return promise so the caller can get results
			return new Promise((resolve, reject) => {
				this.resolvePromise = resolve
				this.rejectPromise = reject
			})
		},

		Copy() {
      //console.log('this.message ',this.message)
			this.copyToClipBoard(this.message)
		},

		Positive() {
			this.$refs.popup.close()
        this.resolvePromise({ answer: "positive" })
		},
	},
}
</script>
